import { EditOutlined } from '@ant-design/icons'
import {
    Button,
    Col,
    Input,
    notification,
    Row,
    Select,
    Spin,
    Table,
} from 'antd'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { listOfRecipesApi } from '../../../config/Api'
import { API_ERR_MESSAGE } from '../../../config/constant'
import { setHeaderName } from '../../../services/SetHeaderName'
import '../ClientsList/style/ClientsList.scss'
import './style/ManageRecipe.scss'

export const ManageRecipe = () => {
    const { Option } = Select

    const data = [
        {
            id: '1',
            name: 'Yellow Moong Dal Cheela Stuffed With Onions',
            lastUpdatedBy: 'Mansi Bhojani',
            lastVerifiedBy: 'Mansi Bhojani',
            // verified: false,
            status: false,
        },
        {
            id: '2',
            name: 'Saute Paneer With Capsicum, Onions And Beans',
            lastUpdatedBy: 'Aakash Parekh',
            lastVerifiedBy: 'Aakash Parekh',
            // verified: true,
            status: true,
        },
        {
            id: '3',
            name: 'Saute Tofu With Capsicum, Onion And Mushrooms',
            lastUpdatedBy: 'Darshit Lathigara',
            lastVerifiedBy: 'Darshit Lathigara',
            // verified: true,
            status: true,
        },
        {
            id: '4',
            name: 'Saute Paneer With Capsicum Onion And Broccoli',
            lastUpdatedBy: 'Milap Parikh',
            lastVerifiedBy: 'Milap Parikh',
            // verified: false,
            status: false,
        },
        {
            id: '5',
            name: '	Multigrain Chapati',
            lastUpdatedBy: 'Bhushan Patadiya',
            lastVerifiedBy: 'Bhushan Patadiya',
            // verified: true,
            status: true,
        },
        {
            id: '6',
            name: 'Yellow Moong Dal Cheela Stuffed With Onions',
            lastUpdatedBy: 'Mansi Bhojani',
            lastVerifiedBy: 'Mansi Bhojani',
            // verified: true,
            status: false,
        },
        {
            id: '7',
            name: 'Saute Paneer With Capsicum, Onions And Beans',
            lastUpdatedBy: 'Aakash Parekh',
            lastVerifiedBy: 'Aakash Parekh',
            // verified: true,
            status: true,
        },
        {
            id: '8',
            name: 'Saute Tofu With Capsicum, Onion And Mushrooms',
            lastUpdatedBy: 'Darshit Lathigara',
            lastVerifiedBy: 'Darshit Lathigara',
            // verified: false,
            status: true,
        },
        {
            id: '9',
            name: 'Saute Paneer With Capsicum Onion And Broccoli',
            lastUpdatedBy: 'Milap Parikh',
            lastVerifiedBy: 'Milap Parikh',
            // verified: false,
            status: false,
        },
        {
            id: '10',
            name: '	Multigrain Chapati',
            lastUpdatedBy: 'Bhushan Patadiya',
            lastVerifiedBy: 'Bhushan Patadiya',
            // verified: true,
            status: true,
        },
        {
            id: '11',
            name: 'Saute Paneer With Capsicum Onion And Broccoli',
            lastUpdatedBy: 'Milap Parikh',
            lastVerifiedBy: 'Milap Parikh',
            // verified: false,
            status: false,
        },
        {
            id: '12',
            name: '	Multigrain Chapati',
            lastUpdatedBy: 'Bhushan Patadiya',
            lastVerifiedBy: 'Bhushan Patadiya',
            // verified: true,
            status: true,
        },
    ]

    const [dataSource, setDataSource] = useState([])
    const [displayData, setDisplayData] = useState([])
    // the table's page, so the # column keeps counting across pages
    const [page, setPage] = useState({ current: 1, pageSize: 15 })
    const [recipeData, setRecipeData] = useState()
    const [isUserHasRecipeRight, setIsUserHasRecipeRight] = useState(false)
    const [userRole, setUserRole] = useState('')
    const [loginUserId, setLoginUserId] = useState('')
    const [isEditVisible, setIsEditVisible] = useState(false)
    const [loading, setLoading] = useState(false)
    // !isUserHasRecipeRight ? 'd-none' : 'd-block'

    // get the list of all Recipes
    // ============================
    const getListOfRecipes = () => {
        setLoading(true)

        listOfRecipesApi()
            .then((res) => {
                if (res.status === 200) {
                    let data = res.data.data
                    let userId = localStorage.getItem('id')
                    let RecipeArray = []
                    if (data?.length > 0) {
                        let roleData = JSON.parse(localStorage.getItem('user'))

                        // admin can see all the recipes
                        // ===============
                        if (roleData?.user?.role == 'Admin') {
                            RecipeArray.push(...data)
                        } else {
                            data.map((element) => {
                                // all recipes that has edit_flag false
                                // ===============
                                if (!element.edit_flag) {
                                    RecipeArray.push(element)
                                }

                                // and compare loginuer id and recipe user id if match and flag is true also display those recipes
                                // ===============
                                console.log(
                                    element.edit_flag == true &&
                                        element.user_id == userId
                                )
                                if (
                                    element.edit_flag == true &&
                                    element.user_id == userId
                                ) {
                                    RecipeArray.push(element)
                                }
                            })
                        }
                    }
                    setDataSource(RecipeArray)
                    setDisplayData(RecipeArray)
                    setLoading(false)
                }
            })
            .catch((err) => {
                console.log('err=>', err)
                notification.error({
                    message: API_ERR_MESSAGE,
                })
                setLoading(false)
            })
    }

    useEffect(() => {
        setHeaderName('Manage Recipe')
        // setDataSource(data)

        const isAddRecipeRight = JSON.parse(localStorage.getItem('user'))
        setIsUserHasRecipeRight(isAddRecipeRight?.user?.add_recipes_right)
        setUserRole(isAddRecipeRight?.user?.role)
        setLoginUserId(isAddRecipeRight?.id)
        if (isAddRecipeRight?.user?.role == 'Admin') {
            setIsEditVisible(true)
        } else {
            // if nutritionist has recipe rights then
            isAddRecipeRight?.user?.add_recipes_right
                ? setIsEditVisible(true)
                : setIsEditVisible(false)
        }

        getListOfRecipes()
    }, [])

    const columns = [
        {
            // position in the list as shown (after search); the ID stays internal
            title: '#',
            key: 'index',
            render: (_, __, index) => (page.current - 1) * page.pageSize + index + 1,
            width: '13%',
            className: 'text-center',
        },
        {
            title: 'Recipe Name',
            dataIndex: 'name',
            key: 'name',
            // sorter: (a, b) => a.name.localeCompare(b.name),
            // render: (text, record) => <Link to={{ pathname: `/patient-detail/${record.id}` }}>{record.name}</Link>,
            width: '58%',
        },
        // {
        //     title: 'Verified?',
        //     dataIndex: 'verified',
        //     key: 'verified',
        //     render: (text, record) => text ? <CheckCircleOutlined className="text-center text-sucess h6" /> : '',
        //     className: "text-center"
        // },
        {
            title: 'Last Updated By',
            dataIndex: 'user',
            key: 'user',
            width: '14%',
            className: 'text-center',
            render: (text, data) => <p className="mb-0">{text?.name}</p>,
        },
        // {
        //     title: 'Last Verified By',
        //     width: "30%",
        //     dataIndex: 'lastVerifiedBy',
        //     key: 'lastVerifiedBy',
        //     className: "text-center"
        // },
        {
            title: 'Action',
            key: 'action',
            // hide buttons if nutritionist doesn't have add recipe rights
            // className: (!isEditVisible && 'd-none'),
            render: (_, record) => (
                // isEditVisible &&
                <div className="action align-self-center">
                    <Link to={{ pathname: `/edit-recipe/${record.id}` }}>
                        <Button
                            icon={<EditOutlined />}
                            className="me-2 bg-primary text-white border-0 rounded"
                        >
                            Edit
                        </Button>
                    </Link>
                    {/* <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record.key)}> */}
                    {/* <Popconfirm title="Sure to delete?" >
                        <Button icon={<DeleteOutlined />} />
                    </Popconfirm> */}
                </div>
            ),
        },
    ]

    // filter recipe list
    // ============================
    const filterRecipeList = (data) => {
        setPage((current) => ({ ...current, current: 1 }))
        if (!data) {
            setDisplayData(dataSource)
        } else {
            let tmp = []
            dataSource.length > 0 &&
                dataSource.forEach((element) => {
                    if (
                        element.name
                            .toUpperCase()
                            .indexOf(data.toUpperCase()) !== -1
                    ) {
                        tmp.push(element)
                    }
                })
            setDisplayData(tmp)
        }
    }

    // filter data according to user search input
    useEffect(() => {
        filterRecipeList(recipeData)
    }, [recipeData])

    return (
        <>
            <div className="ManageRecipe">
                <Row className="mb-2">
                    {/* <Col xl={{ offset: 3, span: 2 }} className="align-self-center"> */}
                    <Col xl={3} className="align-self-center">
                        {/* {
                            isEditVisible &&
                            <Link to={{ pathname: '/add-recipe' }} >
                                <Button htmlType="submit"
                                    //  className="submit-button bg-primary text-white my-2 border-0 rounded ms-2 " icon={<PlusOutlined style={{ fontSize: "1.2rem" }} />}
                                    // onClick={() => setIsModalVisible(true)}
                                    // disabled={isEditVisible ? true : false}
                                    className='submit-button bg-primary text-white my-2 border-0 rounded ms-2'
                                >
                                    Add New Recipe
                                </Button>
                            </Link>
                        } */}
                        {
                            <Link to={{ pathname: '/add-recipe' }}>
                                <Button
                                    htmlType="submit"
                                    className="submit-button bg-primary text-white my-2 border-0 rounded ms-2"
                                >
                                    Add New Recipe
                                </Button>
                            </Link>
                        }
                    </Col>
                    {/* <Col xl={7} className="text-end align-self-center pe-4">
                        <h6 className="mb-0">Total Users: 5 </h6>
                    </Col> */}
                    <Col xl={{ offset: 12, span: 9 }} className="text-end">
                        {/* <Col xl={9} className="text-end"> */}

                        <Input.Search
                            placeholder="Search Recipe"
                            onChange={(e) => {
                                filterRecipeList(e.target.value)
                                setRecipeData(e.target.value)
                            }}
                            className="p-2"
                        />
                    </Col>
                </Row>
                <Spin spinning={loading} className="spinner-code">
                    <Row className="text-center">
                        {/* <Col xl={{ offset: 3, span: 18 }}> */}
                        <Col span={24}>
                            <Table
                                columns={columns}
                                rowKey="id"
                                // oldest recipe first, as when the list was sorted by ID
                                dataSource={[...displayData].sort((a, b) => a.id - b.id)}
                                // pagination={false}
                                scroll={{ x: 'max-content' }}
                                className="w-100"
                                pagination={{ current: page.current, pageSize: page.pageSize }}
                                onChange={(pagination) => setPage({ current: pagination.current, pageSize: pagination.pageSize })}
                            />
                        </Col>
                    </Row>
                </Spin>
            </div>
        </>
    )
}
